import type { Node } from "prosemirror-model";
import type { NodeView } from "prosemirror-view";

import { isFormulaNode } from "../adapter/schema";

export const FORMULA_ERROR_COLOR = "#E84121"; // Red

/** Returns true if the given LaTeX string causes a KaTeX render error. */
export function latexHasError(latex: string): boolean {
  if (!window.katex) return false;

  try {
    window.katex.renderToString(latex, { throwOnError: true });
    return false;
  } catch {
    return true;
  }
}

export class FormulaView implements NodeView {
  dom: HTMLSpanElement;

  constructor(node: Node) {
    this.dom = document.createElement("span");
    this.dom.classList.add("formula");
    if (isFormulaNode(node)) this.renderMath(node.attrs.formula);
  }

  private renderMath(latex: string): void {
    if (!window.katex) {
      this.dom.textContent = latex;
      return;
    }
    window.katex.render(latex, this.dom, {
      throwOnError: false,
      errorColor: FORMULA_ERROR_COLOR,
    });
  }

  update(node: Node): boolean {
    if (!isFormulaNode(node)) return false; // let ProseMirror handle the node view
    this.renderMath(node.attrs.formula);
    return true; // update applied; keep this node view
  }

  // eslint-disable-next-line class-methods-use-this
  ignoreMutation(): boolean {
    // KaTeX injects a complex DOM tree (nested spans, SVGs) inside this.dom.
    // Without this, ProseMirror would interpret those mutations as user edits.
    return true;
  }
}

/** Factory for FormulaView. */
export function formulaNodeView(node: Node): FormulaView {
  return new FormulaView(node);
}
